import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import * as rules from "@/utils/rules";
import states from "@/constants/stateOptions";
import DateInput from "../custom/DateInput.vue";
import VisionVariables from "@/types/VisionVariables";
import FormTitle from "../common/FormTItle.vue";
import TextInput from "../custom/TextInput.vue";
import SelectInput from "../custom/SelectInput.vue";
import PhoneNumberInput from "../custom/PhoneNumberInput.vue";
import ZipCodeInput from "../custom/ZipCodeInput.vue";
import CustomRadioGroup from "../custom/CustomRadioGroup.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PatientInformation',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;



const variables = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        class: "pb-0"
      }, {
        default: _withCtx(() => [
          _createVNode(FormTitle, {
            title: "Patient information",
            description: "Give us some information about who the items were purchased for"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "12",
        md: "6",
        lg: "4",
        class: "py-0"
      }, {
        default: _withCtx(() => [
          _createVNode(TextInput, {
            label: "First name",
            modelValue: variables.value.firstName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((variables.value.firstName) = $event)),
            required: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "12",
        md: "6",
        lg: "4",
        class: "py-0"
      }, {
        default: _withCtx(() => [
          _createVNode(TextInput, {
            label: "Last name",
            modelValue: variables.value.lastName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((variables.value.lastName) = $event)),
            required: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "12",
        md: "6",
        lg: "4",
        class: "py-0"
      }, {
        default: _withCtx(() => [
          _createVNode(TextInput, {
            label: "Middle initial (optional)",
            modelValue: variables.value.middleInitial,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((variables.value.middleInitial) = $event)),
            rules: [rules.middleInitialRule]
          }, null, 8, ["modelValue", "rules"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "12",
        md: "6",
        lg: "4",
        class: "py-0"
      }, {
        default: _withCtx(() => [
          _createVNode(TextInput, {
            label: "Email address",
            modelValue: variables.value.email,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((variables.value.email) = $event)),
            icon: "mdi-email-outline",
            rules: [rules.emailRule],
            required: ""
          }, null, 8, ["modelValue", "rules"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "12",
        md: "6",
        lg: "4",
        class: "py-0"
      }, {
        default: _withCtx(() => [
          _createVNode(PhoneNumberInput, {
            modelValue: variables.value.phoneNumber,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((variables.value.phoneNumber) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "12",
        md: "6",
        lg: "4",
        class: "py-0"
      }, {
        default: _withCtx(() => [
          _createVNode(DateInput, {
            label: "Date of Birth",
            modelValue: variables.value.dateOfBirth,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((variables.value.dateOfBirth) = $event)),
            rules: [rules.requiredRule]
          }, null, 8, ["modelValue", "rules"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "12",
        md: "6",
        lg: "4",
        class: "pt-0"
      }, {
        default: _withCtx(() => [
          _createVNode(CustomRadioGroup, {
            label: "Sex",
            modelValue: variables.value.sex,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((variables.value.sex) = $event)),
            rules: [rules.requiredRule],
            options: [
          { label: 'Male', value: 'male' },
          { label: 'Female', value: 'female' },
        ],
            required: ""
          }, null, 8, ["modelValue", "rules"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "12",
        md: "8",
        lg: "8",
        class: "py-0"
      }, {
        default: _withCtx(() => [
          _createVNode(TextInput, {
            label: "Street Address",
            modelValue: variables.value.addressStreet,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((variables.value.addressStreet) = $event)),
            required: ""
          }, null, 8, ["modelValue"]),
          _createVNode(TextInput, {
            label: "Street Address 2",
            modelValue: variables.value.addressStreet2,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((variables.value.addressStreet2) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "12",
        md: "6",
        lg: "4",
        class: "py-0"
      }, {
        default: _withCtx(() => [
          _createVNode(TextInput, {
            label: "City",
            modelValue: variables.value.addressCity,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((variables.value.addressCity) = $event)),
            required: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "12",
        md: "6",
        lg: "4",
        class: "py-0"
      }, {
        default: _withCtx(() => [
          _createVNode(SelectInput, {
            items: _unref(states),
            label: "State",
            modelValue: variables.value.addressState,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((variables.value.addressState) = $event)),
            required: ""
          }, null, 8, ["items", "modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "12",
        md: "6",
        lg: "4",
        class: "py-0"
      }, {
        default: _withCtx(() => [
          _createVNode(ZipCodeInput, {
            label: "Zip Code",
            modelValue: variables.value.addressZip,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((variables.value.addressZip) = $event)),
            rules: [rules.requiredRule, rules.zipCodeRule],
            required: ""
          }, null, 8, ["modelValue", "rules"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})